<template>
  <div class="outer-step-wrap">
    <div class="step-wrap">
      <ul class="step-list">
        <li :class="['step-item', curStep >= 1 ? 'cur' : '']" @click="changeCurStep(1)">
          <span class="step-num">1</span>
          <span class="step-label">推广计划</span>
        </li>
        <li :class="['step-item', curStep >= 2 ? 'cur' : '']" @click="changeCurStep(2)">
          <span class="step-num">2</span>
          <span class="step-label">基础设置</span>
        </li>
        <li :class="['step-item', curStep >= 3 ? 'cur' : '']" @click="changeCurStep(3)">
          <span class="step-num">3</span>
          <span class="step-label">定向包</span>
        </li>
        <li :class="['step-item', curStep >= 4 ? 'cur' : '']" @click="changeCurStep(4)">
          <span class="step-num">4</span>
          <span class="step-label">预算与出价</span>
        </li>
        <li :class="['step-item', curStep >= 5 ? 'cur' : '']" @click="changeCurStep(5)">
          <span class="step-num">5</span>
          <span class="step-label">创意组</span>
        </li>
        <li :class="['step-item', curStep >= 6 ? 'cur' : '']" @click="changeCurStep(6)">
          <span class="step-num">6</span>
          <span class="step-label">创意标题</span>
        </li>
        <li :class="['step-item', curStep >= 7 ? 'cur' : '']" @click="changeCurStep(7)">
          <span class="step-num">7</span>
          <span class="step-label">其他配置</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curStep: 1,
    };
  },
  methods: {
    changeCurStep(stepNum) {
      if (this.curStep === stepNum) {
        return;
      }
      this.curStep = stepNum;
      this.$emit("changeStep", stepNum);
    },
  },
};
</script>

<style lang="less" scoped>
.outer-step-wrap {
  background-color: #fff;
  width: 200px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  padding: 24px;
  box-sizing: border-box;
  .step-wrap {
    .step-list {
      padding: 0px;
      margin: 0px;
      list-style: none;
      display: flex;
      flex-direction: column;
      // align-items: center;
      justify-content: center;
      .step-item {
        display: flex;
        align-items: center;
        white-space: nowrap;
        position: relative;
        margin-bottom: 62px;
        .step-num {
          flex-shrink: 0;
          display: inline-block;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          line-height: 34px;
          color: rgba(0, 0, 0, 0.25);
          border: 1px solid rgba(0, 0, 0, 0.25);
          text-align: center;
          margin: 0 10px 0px 0px;
        }
        .step-label {
          margin-right: 10px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.45);
          cursor: pointer;
          line-height: 34px;
        }
        &.cur {
          .step-num {
            background: rgba(24, 144, 255, 1);
            color: #fff;
            border: 1px solid rgba(24, 144, 255, 1);
          }
          .step-label {
            color: rgba(0, 0, 0, 0.85);
          }
        }
        &.cur:not(:first-child)::before {
          background: rgba(24, 144, 255, 1);
        }
      }
      // .step-item:not(:first-child) {
      //   width: 14%;
      // }
      .step-item:not(:first-child)::before {
        content: "";
        display: inline-block;
        position: absolute;
        left: 17px;
        bottom: 40px;
        width: 1px;
        height: 50px;
        background: rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
